import React from 'react'
import { __, sprintf } from 'StylistParent/i18n';
import Tooltip from 'Components/tooltip'

/* Import CSS */
// import './index.scss'

class Label extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			isEnabled: false,
		}
	}

	toggleDefault = ( event ) => {
		this.props.onToggleDefault()
		// window.stlst_legacy.defaultButtonAction(event)
	}

	toggleEnabled = ( event ) => {
		/*
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;

		if ( value !== this.state.isEnabled ) {
			this.setState( {
				isEnabled: value,
			} )
		}
		*/
		// this.state.isEnabled = ! this.state.isEnabled;

		this.props.onToggleEnabled()
	}

	isEnabled = () => {
		return this.props.isEnabled;
	}

	componentDidUpdate = ( prevProps, prevState ) => {
		const { cssDefault, currentValue } = this.props

		if ( ! this.props.isEnabled && prevState.currentValue !== currentValue && currentValue !== cssDefault ) {
			// this.props.isEnabled = true
			// this.props.onToggleEnabled()
			// this.state.isEnabled = true

			// this.setState( {
			// 	isEnabled: true,
			// } )
		} else if ( this.state.isEnabled != this.props.isEnabled ) {

			// this.setState( {
			// 	isEnabled: this.props.isEnabled,
			// } )
			// this.state.isEnabled = this.props.isEnabled
		}
	}

	render() {
		const { cssDefault, currentValue } = this.props
		const defaultReset = cssDefault === undefined ? 'none' : cssDefault
		let defaultResetClass = 'stlst-btn-action stlst-none-btn'

		defaultResetClass = defaultReset === false ? `${ defaultResetClass } stlst-action-disabled` : defaultResetClass
		defaultResetClass = defaultReset === this.props.currentValue ? `${ defaultResetClass } active` : defaultResetClass

		return (

			<h4 className="stlst-option-label">
				<input type="checkbox"
					className="stlst-control-status"
					// value={this.state.isEnabled}
					// checked={this.state.isEnabled}
					checked={this.props.isEnabled}
					// defaultChecked={this.props.isEnabled}
					// onChange={this.toggleEnabled}
					onChange={this.props.onToggleEnabled}
					// onChange={this.props.onToggleEnabled()}
				/>
				{/* <button className="stlst-btn-action stlst-disable-btn stlst-components-icon-button" ><svg aria-hidden="true" role="img" focusable="false" className="dashicon dashicons-admin-generic" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><path d="M17.2 4.3L14 4.3 14 3.5C14 2.1 12.9 1 11.6 1L8.4 1C7.1 1 6 2.1 6 3.5L6 4.3 2.8 4.3C2.4 4.3 2 4.6 2 5.1 2 5.5 2.4 5.9 2.8 5.9L3.6 5.9 3.6 16.5C3.6 17.9 4.7 19 6 19L14 19C15.3 19 16.4 17.9 16.4 16.5L16.4 5.9 17.2 5.9C17.6 5.9 18 5.5 18 5.1 18 4.6 17.6 4.3 17.2 4.3ZM7.6 3.5C7.6 3 8 2.6 8.4 2.6L11.6 2.6C12 2.6 12.4 3 12.4 3.5L12.4 4.3 7.6 4.3 7.6 3.5ZM14.8 16.5C14.8 17 14.4 17.4 14 17.4L6 17.4C5.6 17.4 5.2 17 5.2 16.5L5.2 5.9 14.8 5.9 14.8 16.5ZM8.4 8.4C8 8.4 7.6 8.7 7.6 9.2L7.6 14.1C7.6 14.5 8 14.9 8.4 14.9 8.8 14.9 9.2 14.5 9.2 14.1L9.2 9.2C9.2 8.7 8.8 8.4 8.4 8.4ZM11.6 8.4C11.2 8.4 10.8 8.7 10.8 9.2L10.8 14.1C10.8 14.5 11.2 14.9 11.6 14.9 12 14.9 12.4 14.5 12.4 14.1L12.4 9.2C12.4 8.7 12 8.4 11.6 8.4Z" /></svg></button> */}

				<span>
					{this.props.children}
					<Tooltip text={ __( "Default Value" ) }>
						<button
							className={defaultResetClass}
							onClick={this.toggleDefault}
						>{defaultReset}</button>
					</Tooltip>
				</span>
			</h4>

		)
	}
}

export default Label



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/control-label/index.jsx